import styled from 'styled-components';

export const LoaderContainer: any = styled.div`
&& {
    display: block;
    .loader {
        border: 5px solid #f3f3f3;
        border-radius: 50%;
        border-top: 5px solid #3498db;
        width: 60px;
        height: 60px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
        position: fixed;
        top: 50%;
        left: 48%;
        z-index: 999999;
        color: #1c3342;
    }
    
    /* Safari */
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
        }

        @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
}`;

export const OverlayContainer: any = styled.div`
&& {
    width: 100%;
    height: ${(props: any) => props.height ? props.height + 'px' : '100%'};
    // height: 500px;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.9;
    z-index: 999999;
}
`;


// WEBPACK FOOTER //
// ./src/styles/loader.tsx